module.exports = __webpack_public_path__ + "static/media/title.88a397ee.png";